import React from 'react';

function MessageConsultant({children}) {
    return (
        <>
        {/* Consultant Message */}
        <div className="flex items-start mb-4">
            <div className="mr-3 overflow-hidden rounded-full w-[50px] h-[50px]">
              <img src="/assets/img/profile.jpg" alt="Consultant" className="object-cover w-full h-full" />
            </div>
            <div className="flex flex-col max-w-[80%] justify-start items-start">
              <span className="mb-1 text-[13px]">상담사</span>
              {children}
            </div>
          </div>
        </>
    );
}

export default MessageConsultant;
